import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import countDescendants from "../../helper/countDescendants";
import BreadcrumbsLink from "./BreadcrumbsLink";
import BreadcrumbsCurrent from "./BreadcrumbsCurrent";

import { useMediaQuery, breakpoints } from "../hooks/useMediaQuery";

import ContinueIcon from "./ContinueIcon";

import styles from "./Breadcrumbs.scss";

export const Breadcrumbs = forwardRef((props, ref) => {
  const { children, links, ...other } = props;
  const numBreadcrumbs =
    countDescendants({ props }, [
      BreadcrumbsLink.displayName,
      BreadcrumbsCurrent.displayName,
    ]) + links.length;
  const untilViewportL = useMediaQuery(`(max-width: ${breakpoints.l - 1}px)`);
  const displayDots = untilViewportL && numBreadcrumbs > 2;

  return (
    <div ref={ref} className={styles.breadcrumbs} {...other}>
      <ul className={styles.list}>
        {displayDots && (
          <li className={styles.dots} aria-hidden="true">
            <span>...</span>
            <ContinueIcon />
          </li>
        )}

        {links.map((link, index) => (
          <>
            {index === links.length - 1 ? (
              <Breadcrumbs.Current>{link.label}</Breadcrumbs.Current>
            ) : (
              <Breadcrumbs.Link href={link.url}>{link.label}</Breadcrumbs.Link>
            )}
          </>
        ))}

        {children}
      </ul>
    </div>
  );
});

Breadcrumbs.propTypes = {
  // TODO: mark as required if deprecated links solution was removed
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /**
   * @deprecated Use children instead.
   */
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string,
    })
  ),
};

Breadcrumbs.defaultProps = {
  children: null,
  links: [],
};

// Export child components
Breadcrumbs.Link = BreadcrumbsLink;
Breadcrumbs.Current = BreadcrumbsCurrent;

Breadcrumbs.displayName = "Breadcrumbs";

export default Breadcrumbs;
